define('bizzabo/views/main/sponsors/EditPartnersView',[
    'jquery',
    'backbone',
    'bizzabo/config',
    'bizzabo/consts',
    'bizzabo/models/Global',
    'bizzabo/models/Partner',
    'bizzabo/views/popup/ConfirmDialogView',
    'bizzabo/views/popup/ImportPartnersView',
    'hbars!bizzabo/templates/editPartners',
    'hbars!bizzabo/templates/partnerPreview'
], function(
    $,
    Backbone,
    CONFIG,
    Consts,
    Global,
    Partner,
    ConfirmDialogView,
    ImportPartnersView,
    editPartnersTemplate,
    partnerPreviewTemplate
    ) {

    var EditPartnersView = Backbone.View.extend({

        events : {
            'click .addNewSponsorBtn' : 'formAddNewPartnerClicked',
            'click .editTiersBtn' : 'formEditTiersClicked',
            'click .importPartnersBtn' : 'formImportPartnersClicked',
            'click .exportPartnersBtn' : 'formExportPartnersClicked'
        },

        partners : undefined,
        servicePlan : undefined,
        partnerSubViews : undefined,

        initialize : function() {
            var eventId = this.model.get("id");
            this.partnerSubViews = {};
            this.partners = Global.modelPool.getPartners(eventId);
            this.servicePlan = Global.modelPool.getServicePlan(eventId);
            this.listenTo(Backbone, Consts.Notifications.sponsors.DELETE_SPONSOR, this.removePartner);
            this.listenTo(Backbone, Consts.Notifications.sponsors.CLEAR_SELECTED_SPONSOR, this.clearSelectedPartner);
            this.listenTo(this.partners, 'change add remove', this.partnerChanged);
            this.listenTo(this.partners, 'add', this.addPartnerSubView);
            this.listenTo(this.partners, 'remove', this.removePartner);
            this.listenTo(this.partners, 'reset', this.renderPartnersList);
            this.listenTo(this.partners, 'add remove reset', this.renderPartnersCount);
            this.listenTo(this.servicePlan, 'change:sponsors change:exhibitors', this.renderAllowedPartnersCount);
        },

        partnerChanged : function () {
            this.partners.wasChanged = true;
        },

        remove : function() {
            this.removeSubViews();
            this.stopListening();
            this.$el.remove();
        },

        removeSubViews : function() {
            _.chain(this.partnerSubViews).values().invoke('remove');
            this.partnerSubViews = {};
        },

        scrollToView : function(view) {
            var scroller = $('html, body');
            _.defer(function() {
                var offsetFromTop = 125;
                scroller.animate({
                    scrollTop : view.$el.offset().top - scroller.offset().top + scroller.scrollTop() - offsetFromTop
                }, 700);
            });
        },

        render : function() {
            var extendedJSON = {
                event : this.model.toJSON(),
                eventId : this.model.id,
                servicePlan : this.servicePlan.toJSON,
                isSponsors : this.options.isSponsors,
                upgradeUrlQuery : this.servicePlan.upgradeUrlQuery()
            };
            var html = editPartnersTemplate(extendedJSON);
            this.$el.html(html);

            this.renderPartnersList();
            return this;
        },

        rendered : function() {
            var deepLinkParams = this.options.deepLinkParams;
            var partnerCid = deepLinkParams && deepLinkParams.cid;
            var thisView = this;
            if (partnerCid) {
                var partnersPreviewView = this.partnerSubViews[partnerCid];
                partnersPreviewView && partnersPreviewView.editPartnerClicked && _.defer(function() {
                    partnersPreviewView.editPartnerClicked({
                        deepLinkParams : deepLinkParams
                    });
                    thisView.scrollToView(partnersPreviewView);
                });
            }
        },

        renderPartnersList : function() {
            var containerEl = this.$(".sponsorsList");
            containerEl.empty();

            for (var i in this.partners.models) {
                var partnerModel = this.partners.at(i);
                var partnerType = partnerModel.get("partner-type");
                var partnersPreviewView = this.addPartnerSubView(partnerModel);
                partnersPreviewView.selectPartner();
            }
            this.clearSelectedPartner();

            var thisView = this;
            containerEl.sortable({
                placeholder : "inDragPlaceHolder",
                start : function(event, ui) {
                    var cid = ui.item.find(".cid").val();
                    thisView.formDragStarted(thisView, cid);
                },
                stop : function(event, ui) {
                    var cid = ui.item.find(".cid").val();
                    var index = ui.item.index();
                    thisView.formDragFinished(thisView, cid, index);
                }
            });

            containerEl.disableSelection();
            this.renderPartnersCount();
            this.renderAllowedPartnersCount();
        },

        renderPartnersCount : function() {
            this.$(".sponsorsCount").html(this.getNumberOfPartners());
            this.renderPartnersLeft();
        },

        renderAllowedPartnersCount : function() {
            var attr = this.options.isSponsors ? "sponsors" : "exhibitors";
            var allowedPartners = this.servicePlan.get(attr) || 0;
            this.$(".sponsorsInServicePlanCount").html(allowedPartners);
            this.renderPartnersLeft();
        },

        renderPartnersLeft : function() {
            var attr = this.options.isSponsors ? "sponsors" : "exhibitors";
            var allowedPartners = this.servicePlan.get(attr) || 0;
            var partnersLength = this.getNumberOfPartners();
            var diff = Math.max(allowedPartners - partnersLength, 0);
            this.$(".sponsorsLeftCount").html(diff);
            this.renderMsgs();
        },

        renderMsgs : function() {
            var attr = this.options.isSponsors ? "sponsors" : "exhibitors";
            var allowedPartners = this.servicePlan.get(attr) || 0;
            var showNoServicePlanMsg = (allowedPartners == 0);
            var showTooManyPartnersMsg = (allowedPartners < this.getNumberOfPartners()) && !showNoServicePlanMsg;
            this.$(".noPackageMsg").toggleClass("hide", !showNoServicePlanMsg);
            this.$(".tooManySponsorsMsg").toggleClass("hide", !showTooManyPartnersMsg);
        },

        getNumberOfPartners : function() {
            var check = this.options.isSponsors ? "sponsor" : "exhibitor";
            var counts = _.filter(this.partners.models, function(model) {
                return model.get("partner-type") == check;
            });
            return counts.length;
        },

        addPartnerSubView : function(partnerModel) {
            var partnerType = partnerModel.get('partner-type');
            var isDisplayed = (this.options.isSponsors && partnerType == 'sponsor') || (!this.options.isSponsors && partnerType == 'exhibitor');
            var partnersPreviewView = new PartnersPreviewView({
                model : {
                    sponsor : partnerModel,
                    event : this.model,
                    isDisplayed : isDisplayed
                },
                parentView : this
            });
            this.partnerSubViews[partnerModel.cid] = partnersPreviewView;
            partnersPreviewView.render();
            var index = this.partners.indexOf(partnerModel);
            if (index == 0) {
                this.$(".sponsorsList").append(partnersPreviewView.el);
            } else {
                this.$(".sponsorsList > div").eq(index - 1).after(partnersPreviewView.el);
            }
            return partnersPreviewView;
        },

        clearSelectedPartner : function() {
            this.$(".selected").removeClass("selected");
        },

        // form

        formDragStarted : function(context, PartnerModelCid) {
            var partnerSubView = context.partnerSubViews[PartnerModelCid];
            partnerSubView.$el.addClass("dragged");
        },

        formDragFinished : function(context, partnerModelCid, index) {
            var partnerSubView = context.partnerSubViews[partnerModelCid];
            partnerSubView.$el.removeClass("dragged");

            var model = partnerSubView.model.sponsor;
            context.partners.remove(model, {
                silent : true
            });
            context.partners.add(model, {
                silent : true,
                at : index
            });
        },

        formAddNewPartnerClicked : function() {
            var newModel = new Partner({
                "partner-type" : this.options.isSponsors ? "sponsor" : "exhibitor"
            });

            // adding the model to the right place in the collection
            var lastIndex = 0;
            for (var partnerIndex in this.partners.models) {
                if (this.partners.at(partnerIndex).get("partner-type") == this.options.isSponsors ? "sponsor" : "exhibitor") {
                    lastIndex = partnerIndex;
                }
            }
            var atObject = lastIndex == this.partners.length ? undefined : {
                at : lastIndex + 1
            };
            this.partners.add(newModel, atObject);

            Backbone.trigger('editPartnerClicked', newModel);
        },

        removePartner : function(partner) {
            var partnerSubView = this.partnerSubViews[partner.cid];
            partnerSubView.remove();
            this.partners.remove(partner);
        },

        formEditTiersClicked : function() {
            Backbone.trigger('editTiersClicked');
        },

        formImportPartnersClicked : function() {
            var thisView = this;
            //require(['bizzabo/views/popup/ImportPartnersView'], function(ImportPartnersView) {
                new ImportPartnersView({
                    model : thisView.model
                }).show();
            //});
        },

        formExportPartnersClicked : function() {
            var thisView = this;

            var actionFunction = function() {
                Backbone.trigger(Consts.Notifications.mainPage.SAVE_ALL_REQUEST, thisView.exportPartners);
            };

            if (this.partners.wasChanged) {
                new ConfirmDialogView({
                    title : 'Unsaved work',
                    text : 'You have unsaved data, would you like to save changes?',
                    confirm : 'Save & Export',
                    cancel : 'Cancel',
                    onConfirm : actionFunction
                }).show();
            } else {
                this.exportPartners();
            }
        },

        exportPartners : function() {
            var eventId = Global.modelPool.getActiveEvent().get("id");
            var url = CONFIG.SERVER_URL + '/api/v1/organizer/event/' + eventId + '/partners.xls';
            window.open(url, '_blank');
        }

    });

    var PartnersPreviewView = Backbone.View.extend({

        events : {
            'click' : 'editPartnerClicked'
        },

        isValid : true,

        initialize : function() {
            //todo re-render when analytics change too
            this.listenTo(this.model.sponsor, 'change:logo-url change:company-name change:description change:offer-text change:location-at-event', this.render);
            this.listenTo(this.model.sponsor, 'change:tier', this.modelTierChanged);
            this.listenTo(this.model.sponsor, 'validated', this.toggleValidation);
            this.bindTier();
            if (!this.model.sponsor.isBrandNew()) {
                this.model.sponsor.validate();
            }
        },

        remove : function() {
            this.model.tier && this.unbindTier();
            this.stopListening();
            this.$el.remove();
        },

        bindTier : function() {
            this.model.tier && this.unbindTier();

            var modelTier = this.model.sponsor.get("tier");
            if (modelTier) {
                var tiers = this.model.event.get("tier-configuration");
                this.model.tier = tiers.where({
                    "tier" : modelTier
                })[0];
                this.model.tier && this.listenTo(this.model.tier, 'change', this.renderTier);
            } else {
                delete this.model.tier;
            }
        },

        unbindTier : function() {
            this.stopListening(this.model.tier);
            this.model.tier = undefined;
        },

        render : function() {
            if (this.model.isDisplayed) {
                var source = _.extend(this.model.sponsor.toJSON(), {
                    cid : this.model.sponsor.cid,
                    totalActions : this.model.sponsor.calculateTotalActions()
                });
                var html = partnerPreviewTemplate(source);
                this.$el.html(html);
                this.bindTier();
                this.renderTier();
            } else {
                this.$el.hide();
            }
            return this;
        },

        renderTier : function() {
            var el = this.$(".sponsorTier");
            var modelTier = this.model.tier;
            if (modelTier) {
                el.show();
                el.html(modelTier.get("label"));
                el.css("background-color", "#" + modelTier.get("color"));
            } else {
                el.hide();
            }
        },

        modelTierChanged : function() {
            this.bindTier();
            this.renderTier();
        },

        editPartnerClicked : function(e) {
            var deepLinkParams = e && e.deepLinkParams;
            this.selectPartner();
            Backbone.trigger('editPartnerClicked', this.model.sponsor, deepLinkParams);
        },

        selectPartner : function() {
            Backbone.trigger(Consts.Notifications.sponsors.CLEAR_SELECTED_SPONSOR);
            this.$el.addClass("selected");
        },

        toggleValidation : function() {
            var shouldSkipValidationError = !this.model.sponsor.wasEdited && !this.model.sponsor.isSynced;
            if (shouldSkipValidationError) {
                return;
            }

            var isValid = this.model.sponsor.isValid() ? true : this.model.sponsor.isBrandNew();
            if (isValid != this.isValid) {
                this.$el.toggleClass('error', !isValid);
                this.isValid = isValid;
            }
        }
    });

    return EditPartnersView;

});
